const teamHash = 'meme';
const io = (window as any).io;
export const socket = io('https://socketiobackend.studiomaid.nl');

socket.on("connect", () => {
  console.log("connected");
});

socket.on("connect_error", (err: any) => {
  console.log("Connection error:", err.message);
});

socket.on("disconnect", (reason: string) => {
  console.log("Disconnected:", reason);
});

export default function emitMessage(data: string): void {
  socket.emit('messageFromBrowser', {
    content: data,
    teamHash: teamHash
  })
}

socket.on('messageToUnity', (data: any) => {
  if (teamHash !== data.teamHash) return;
  console.log('Message from Browser client: ', data);
});


socket.on('messageToBrowser', (data: any) => {
  if (data.teamHash !== teamHash) return
  console.log('Message from Unity:', data);
});

